var _g, _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckPurpleCircleRipple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_22464_101177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 30,
    fill: "#E4DCF3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#492897"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 42H49.2529C49.4364 42 49.5281 42 49.6144 42.0207C49.691 42.0391 49.7641 42.0694 49.8312 42.1105C49.9069 42.1569 49.9718 42.2218 50.1015 42.3515L53.1485 45.3985C53.2782 45.5282 53.3431 45.5931 53.3895 45.6688C53.4306 45.7359 53.4609 45.809 53.4793 45.8856C53.5 45.9719 53.5 46.0636 53.5 46.2471V48.375C53.5 48.7245 53.5 48.8992 53.4429 49.037C53.3668 49.2208 53.2208 49.3668 53.037 49.4429C52.8992 49.5 52.7245 49.5 52.375 49.5M48.625 49.5H47.5M47.5 49.5V42.15C47.5 41.3099 47.5 40.8899 47.3365 40.569C47.1927 40.2868 46.9632 40.0573 46.681 39.9135C46.3601 39.75 45.9401 39.75 45.1 39.75H40.9C40.0599 39.75 39.6399 39.75 39.319 39.9135C39.0368 40.0573 38.8073 40.2868 38.6635 40.569C38.5 40.8899 38.5 41.3099 38.5 42.15V48C38.5 48.8284 39.1716 49.5 40 49.5M47.5 49.5H44.5M44.5 49.5C44.5 50.7426 43.4926 51.75 42.25 51.75C41.0074 51.75 40 50.7426 40 49.5M44.5 49.5C44.5 48.2574 43.4926 47.25 42.25 47.25C41.0074 47.25 40 48.2574 40 49.5M52.375 49.875C52.375 50.9105 51.5355 51.75 50.5 51.75C49.4645 51.75 48.625 50.9105 48.625 49.875C48.625 48.8395 49.4645 48 50.5 48C51.5355 48 52.375 48.8395 52.375 49.875Z",
    stroke: "#492897",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22464_101177",
    x: 0.285012,
    y: 0.285012,
    width: 91.43,
    height: 91.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85749
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22464_101177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22464_101177",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckPurpleCircleRipple);
export default __webpack_public_path__ + "static/media/truck_purple_circle_ripple.84ca42f442b581a9d9211dbbafc4025f.svg";
export { ForwardRef as ReactComponent };